export const FOLDER_IDS = {
  ROOT: -1,
  SHAREDWITHME: -2,
  RECYCLEBIN: -10,
  ARCHIVE: -15,
  ARCHIVEFILE: -20,
} as const;
